import styles from './ExpandedQuantityTab.module.scss';

interface ExpandedQuantityTabProps {
  remainingCount: number;
}

export default function ExpandedQuantityTab({ remainingCount }: ExpandedQuantityTabProps) {
  return (
    <div className={styles.moreIndicator}>+{remainingCount}</div>
  );
}

